import React from 'react';

import CustomButton from "components/CustomButton";

const ActionButtonContentContainer = (props) => (
    <div style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '8px',
    }}>
        {props.children}
    </div>
)

function Actions(props) {
    return (
        <div style={{display: 'flex', gap: '8px'}}>
            <CustomButton variant={'outlined'} color={'default'}>
                <ActionButtonContentContainer>
                    <svg width='15' height='15' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.5'
                         strokeLinecap='round' strokeLinejoin='round'>
                        <line x1='18' y1='6' x2='6' y2='18'/>
                        <line x1='6' y1='6' x2='18' y2='18'/>
                    </svg>
                    Annuler tout
                </ActionButtonContentContainer>
            </CustomButton>
            <CustomButton>
                <ActionButtonContentContainer>
                    <svg width='15' height='15' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.5'
                         strokeLinecap='round' strokeLinejoin='round'>
                        <polyline points='20 6 9 17 4 12'/>
                    </svg>
                    Valider tout
                </ActionButtonContentContainer>
            </CustomButton>
        </div>
    );
}

export default Actions;
